import { BCMSDate, Branding, BrandingStyle, DisabledPrompt, Link, StateManager, useBCMSContext, useModel, useParams, useRoute, useStateManager } from '@bcm-dev/bcms-vite';
import { Card, Transaction, Util } from "model";
import React from "react";

import { MainContentSection } from "components/shared/containers/MainContentContainer";
import TransactionView from "components/shared/views/BaseRowView/components/TransactionView";
import { useOutletContext } from "react-router";

import UITransactionSearch from "components/ui/UITransactionSearch";
import "./styles.css";
/**
 * @function PurchasesView
 * @return {React.Component}
 * @exported true
 * @description The main component for PurchasesView
 */

export default function PurchasesView(props) {
  // Using "useOutletContext" hook in order to pass data to "Outlet" instance.
  // This component is an outlet of "ViewAllTransactionsPage".
  const outletContext = useOutletContext();
  let dataObj = outletContext ? outletContext[0].data : {};
  const model = useModel();
  let cardID = useParams().cardID ?? Util.getDefaultCardID(model);
  const { branding } = useModel();
  const options = branding.options ?? {};
  // If the credit card is off, then debit card has to be used.
  if(options.include_credit_chw23 === "false") {
      cardID = "0";
  }
  const data = { ...getDefaultData(cardID), ...dataObj.data ?? {}, ...props.data ?? {} };
  const ui = { ...getDefaultUI(), ...dataObj.ui ?? {}, ...props.ui ?? {} };

  const controller = (state, setState) => ({
    data: state.data,
    ui: state.ui,
  });

return (
  <StateManager state={ { data, ui } } controller={ controller }>
      <PageContent/>
  </StateManager>
);
}

export const getDefaultData = cardID => {
  const _cardID = cardID ? cardID : "0";
  // Initalize the card by id and get all transactions for the card
  const card = Card.initByID(_cardID);
  const transactions = Transaction.getByCard(card.id);

  return {
      card,
      transactions
  };
}

export const getDefaultUI = () => ({

});

function PageContent(props) {
  const { data, ui } = useStateManager();
    // Get the card id from the parameters
    const navigate = useRoute();
    //const cardID = useParams().cardID ?? "0";
    // Initalize the card by id and get all transactions for the card
    //const card = Card.initByID(cardID);
    //let transactions = Transaction.getByCard(card.id);
    const globalController = useBCMSContext();
  
    if (globalController.state.branding.options.credit_select_chw23 !=="true"){
      data.transactions = data.transactions.filter((transaction)=> transaction.merchant.name !== "Payment")
    }
    // createItem :: Transaction -> React.Component
    // For the given transaction create and return a new TransactionView component
    const createItem = transaction => {
      const onClick = transaction.merchant.name !== "Payment"? evt => navigate(`/home/transactiondetails/${ data.card.id }/${ transaction.id }`): ()=>{};
      const isCredit = transaction.credit === true;
      const disputeStatus = transaction.disputeTransaction ? transaction.disputeTransactionType.description : "";
  
      return transaction.merchant.name !== "Payment" ?
       <TransactionView
        dataPoint={ `Transaction_Row_${ transaction.id }` }
        key={ `Transaction_${ transaction.id }` }
        transaction={ transaction }
        billerName={ transaction.merchant.name }
        date={ transaction.purchaseDate.format("M d, Y") }
        amount={ `${ isCredit ? "+" : "" }${ transaction.amount.format() }` }
        leftIcon={ transaction.merchant.logo }
        onClick={ onClick }
        positiveClassName={ isCredit ? "is-credit" : "" }
        disputeStatus={ disputeStatus }
        id={ transaction.id } />:
        <div key={ `Transaction_${ transaction.id }` }>
          <DisabledPrompt>
            <TransactionView
            dataPoint={ `Transaction_Row_${ transaction.id }` }
            key={ `Transaction_${ transaction.id }` }
            billerName={ transaction.merchant.name }
            date={ transaction.purchaseDate.format("M d, Y") }
            amount={ `${ isCredit ? "+" : "" }${ transaction.amount.format() }` }
            leftIcon={ transaction.merchant.logo }
            onClick={ onClick }
            positiveClassName={ isCredit ? "is-credit" : "" }
            id={ transaction.id } />
          </DisabledPrompt>
        </div>
    };
  
    // createView :: BCMSDate, [ Transaction ] -> React.Component
    // Return a new MainContentSection with all transaction rows
    const createView = (date, transactions, index) => {
      return (
        <MainContentSection key={ `Header_${ index }` } text={ date.format("F Y") } dataPoint={ `Transaction_Header_${ index }` }>
          { transactions.map(item => createItem(item), []) }
        </MainContentSection>
      );
    };
  
    // getOffsets :: [ Transaction ] -> OBJECT
    // Return an object of all transactions filtered into seperate arrays by months
    const getOffsets = transactions => transactions.reduce((result, item) => {
      const date = BCMSDate.init().setToFirst();
      
      date.month = item.purchaseDate.monthInt;
      date.year = item.purchaseDate.yearInt;
  
      const dateStr = date.format("M d, Y");
  
      if(result[dateStr] === undefined) { result[dateStr] = []; }
      return { ...result, [ dateStr ] : [ ...result[dateStr], item ] };
    }, {});
  
    // Filter transactions into either the pending or posted array
    const pending = data.transactions.filter(item => item.status.toLowerCase() === "pending", []);
    const posted = data.transactions.filter(item => item.status.toLowerCase() !== "pending", []);
    // For all transactions that are pending, return a created transaction item
    const pendingViews = pending.map(item => createItem(item), []);
    // Get the offset of the posted transactions
    const postedOffset = getOffsets(posted);
    // For all months that have transactions, create an array of sections
    const postedViews = Object.keys(postedOffset).reduce((result, key, index) => {
      const date = BCMSDate.init(new Date(key));
      return [ ...result, createView(date, postedOffset[key], index) ];
    }, []);
    // Delcare the end and start dates to the first and last transactions
    const endDate = data.transactions[0].purchaseDate.format("M d, Y");
    const startDate = data.transactions[data.transactions.length - 1].purchaseDate.format("M d, Y");
    const downloadRoute = `/home/transactiondownload/${ data.card.id }`;

  return (
  <div className="purchases-view">
      {/* UISearch */}
      <Branding id="transaction_search_chw23" value="true">
        <div className="flex-container flex-horizontal align-center-container ui-transaction-search-input-container">
          <UITransactionSearch placeholder="Search by Keyword" className="flex-width" dataPoint="View_All_Transaction_Search" />
          
          <DisabledPrompt>
            <Link className="set-width filter-text clickable" dataPoint="Filter">Filter</Link>
          </DisabledPrompt>

          <Branding id="downloadall_chw23" value="Both" default="None">
            <BrandingStyle style={{ "color" : "link_chw23" }}>
              <Link className="set-width download-text clickable" dataPoint="Download" to={ downloadRoute }>Download</Link>
            </BrandingStyle>
          </Branding>
          
          
        </div>
      </Branding>
    
      <MainContentSection text="Pending Transactions" dataPoint="Pending_Transactions_Header">
        { pendingViews }
      </MainContentSection>

      { postedViews }

      {/* <div className="text-container flex-container flex-horizontal align-center-container">
        <SVGAsset id="InformationIcon" className="set-width left-icon-container" />
        <p className="sub-text">View statements for all transactions.</p>
      </div> */}
    </div>  
  );
}